import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "spot-exchange-mobile-view" }
const _hoisted_2 = { class: "spot-exchange-mobile-view__trade-actions" }
const _hoisted_3 = { class: "spot-exchange-mobile-view__order-form" }
const _hoisted_4 = { class: "spot-exchange-mobile-view__order-book" }
const _hoisted_5 = {
  key: 1,
  class: "spot-exchange-mobile-view__charting-container"
}
const _hoisted_6 = { class: "spot-exchange-mobile-view__tabs spot-exchange-mobile-view__tabs--charting" }
const _hoisted_7 = { class: "spot-exchange-mobile-view__chart" }
const _hoisted_8 = {
  key: 2,
  class: "spot-exchange-mobile-view__history-container"
}
const _hoisted_9 = {
  key: 3,
  class: "spot-exchange-mobile-view__my-orders-container"
}

import type { OtTabType } from '@1trading/design-system';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { TradingChartContainer } from '@exchange/libs/charting/ui/src';
import { marketService } from '@exchange/libs/market/service/src';
import MarketHeaderDetailsMobile from '@exchange/libs/market/ui/src/lib/components/MarketHeaderDetailsMobile.vue';
import MarketHeaderMobile from '@exchange/libs/market/ui/src/lib/components/MarketHeaderMobile.vue';
import MyOrdersContainer from '@exchange/libs/order/my-orders/ui/src/lib/MyOrdersContainer.vue';
import { OrderContainer } from '@exchange/libs/order/order-form/ui/src';
import OrderBuySellPanel from '@exchange/libs/order/order-form/ui/src/lib/OrderBuySellPanel.vue';
import { DepthChartContainer } from '@exchange/libs/orderbook/depth-chart/ui/src';
import OrderbookContainer from '@exchange/libs/orderbook/orderbook/ui/src/lib/OrderbookContainer.vue';
import { PriceTicksHistoryContainer } from '@exchange/libs/price-ticks/ui/src';
import RibbonSection from '@exchange/libs/ribbons/RibbonSection.vue';
import { currencyService } from '@exchange/libs/utils/currency/src';

import HeaderMobile from '../app-header/HeaderMobile.vue';

type MobileTradingPageSlide = (typeof mobileTradingPageSlides)[keyof typeof mobileTradingPageSlides];

type ChartsType = (typeof chartsTypes)[keyof typeof chartsTypes];


export default /*#__PURE__*/_defineComponent({
  __name: 'SpotExchangeMobileView',
  props: {
  accountId: { type: String, required: false },
  marketId: { type: String, required: true },
},
  emits: ["go-back"],
  setup(__props, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n({ useScope: 'global' });

const { getMarket } = marketService;
const { defaultFiatCurrency, currencies } = currencyService;

const tradeContent = ref<HTMLElement>();

const market = computed(() => getMarket(props.marketId));

const mobileTradingPageSlides = {
  trade: 'trade',
  depth: 'depth',
  history: 'history',
  myorders: 'myorders',
} as const;
const chartsTypes = {
  depth: 'depth',
  tv: 'tv',
} as const;
const getTabs = () => [
  {
    getTitle: () => t('modules.singleMarketSlider.trade'),
    id: mobileTradingPageSlides.trade,
    active: true,
  },
  {
    getTitle: () => 'Chart',
    id: mobileTradingPageSlides.depth,
    active: false,
  },
  {
    getTitle: () => t('modules.singleMarketSlider.history'),
    id: mobileTradingPageSlides.history,
    active: false,
  },
  {
    getTitle: () => 'Portfolio',
    id: mobileTradingPageSlides.myorders,
    active: false,
  },
];

const tabs = ref<Array<OtTabType<MobileTradingPageSlide>>>(getTabs());
const activeTab = computed(() => tabs.value.find((e) => e.active)?.id);

const chartTabs = ref<Array<OtTabType<ChartsType>>>([
  {
    getTitle: () => t('modules.singleMarketSlider.tradingView'),
    id: chartsTypes.tv,
    active: true,
  },
  {
    getTitle: () => t('modules.singleMarketSlider.depth'),
    id: chartsTypes.depth,
    active: false,
  },
]);
const activeChartTab = computed(() => chartTabs.value.find((e) => e.active)?.id);

const moveBack = ref(false);
const prevTav = ref<MobileTradingPageSlide>(mobileTradingPageSlides.trade);

const onTabSelected = (tab: OtTabType<MobileTradingPageSlide>) => {
  const currentTabIndex = tabs.value.findIndex((tb) => tb.id === tab.id);
  const previousTabIndex = tabs.value.findIndex((tb) => tb.id === prevTav.value);

  // If current tab is to the left of previous tab, slide back (right to left)
  moveBack.value = currentTabIndex < previousTabIndex;
  prevTav.value = tab.id;
};

const onGoBack = () => emit('go-back');

const onScrollContent = (top: number) => {
  if (!tradeContent.value) {
    return;
  }

  const contentTop = tradeContent.value.getBoundingClientRect().top;

  tradeContent.value.scroll({
    top: top - contentTop,
    behavior: 'smooth',
  });
};

return (_ctx: any,_cache: any) => {
  const _component_ot_tabs = _resolveComponent("ot-tabs")!
  const _component_x_transition_slide = _resolveComponent("x-transition-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RibbonSection, { market: market.value }, null, 8, ["market"]),
    _createVNode(HeaderMobile, {
      class: "spot-exchange-mobile-view__header",
      "wide-main-content": true,
      onGoBack: onGoBack
    }, {
      "top-content": _withCtx(() => [
        (market.value)
          ? (_openBlock(), _createBlock(MarketHeaderMobile, {
              key: 0,
              market: market.value
            }, null, 8, ["market"]))
          : _createCommentVNode("", true)
      ]),
      "main-content": _withCtx(() => [
        _createVNode(_component_ot_tabs, {
          tabs: tabs.value,
          "onUpdate:tabs": _cache[0] || (_cache[0] = ($event: any) => ((tabs).value = $event)),
          class: "spot-exchange-mobile-view__tabs",
          dense: false,
          scrollable: true,
          onTabSelected: onTabSelected
        }, null, 8, ["tabs"]),
        (market.value)
          ? (_openBlock(), _createBlock(MarketHeaderDetailsMobile, {
              key: 0,
              market: market.value,
              currencies: _unref(currencies),
              "default-fiat-currency": _unref(defaultFiatCurrency)
            }, null, 8, ["market", "currencies", "default-fiat-currency"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_x_transition_slide, {
      push: true,
      "is-xs": true,
      "move-back": moveBack.value
    }, {
      default: _withCtx(() => [
        (activeTab.value === mobileTradingPageSlides.trade)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              ref_key: "tradeContent",
              ref: tradeContent,
              class: "spot-exchange-mobile-view__trade-container"
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(OrderContainer), {
                    "market-id": __props.marketId,
                    "transparent-background": true
                  }, null, 8, ["market-id"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(OrderbookContainer, {
                    "market-id": __props.marketId,
                    mini: true,
                    "show-title": false
                  }, null, 8, ["market-id"])
                ])
              ])
            ], 512))
          : _createCommentVNode("", true),
        (activeTab.value === mobileTradingPageSlides.depth)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_ot_tabs, {
                  tabs: chartTabs.value,
                  "onUpdate:tabs": _cache[1] || (_cache[1] = ($event: any) => ((chartTabs).value = $event)),
                  dense: false
                }, null, 8, ["tabs"])
              ]),
              _createElementVNode("div", _hoisted_7, [
                (activeChartTab.value === chartsTypes.tv)
                  ? (_openBlock(), _createBlock(_unref(TradingChartContainer), {
                      key: __props.accountId,
                      "market-id": __props.marketId
                    }, null, 8, ["market-id"]))
                  : _createCommentVNode("", true),
                (activeChartTab.value === chartsTypes.depth)
                  ? (_openBlock(), _createBlock(_unref(DepthChartContainer), {
                      key: 1,
                      "market-id": __props.marketId
                    }, null, 8, ["market-id"]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(OrderBuySellPanel, { "market-id": __props.marketId }, null, 8, ["market-id"])
            ]))
          : _createCommentVNode("", true),
        (activeTab.value === mobileTradingPageSlides.history)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(PriceTicksHistoryContainer), {
                "market-id": __props.marketId,
                "show-title": false
              }, null, 8, ["market-id"])
            ]))
          : _createCommentVNode("", true),
        (activeTab.value === mobileTradingPageSlides.myorders)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(), _createBlock(MyOrdersContainer, {
                key: `${__props.accountId}-${_ctx.subaccountType}`,
                "market-id": __props.marketId,
                "onMyOrders:scrollContent": onScrollContent
              }, null, 8, ["market-id"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["move-back"])
  ]))
}
}

})